import {Grid, Typography} from '@yandex-delivery/blocks'
import {tag2url} from '@yandex-delivery/utils'
import React from 'react'

import {logoClasses} from './FooterLogo@mobile.classes'

export type FooterLogoProps = {
  phrase1: string | JSX.Element
  invert?: boolean
}

export function FooterLogoMobile({phrase1, invert}: FooterLogoProps) {
  return (
    <Grid direction="column" container>
      <Grid className={logoClasses.gap} direction={invert ? 'column-reverse' : 'column'} container>
        <Typography className={logoClasses.phrase} color="invert" thickness="regular" variant="title2">
          {phrase1}
        </Typography>
        <Grid alignItems="center" container item>
          <img alt="arrow" src={tag2url('delivery_footer_arrow')} className={logoClasses.arrow} />
          <img alt="logo" src={tag2url('delivery_go_logo')} className={logoClasses.logo} />
        </Grid>
      </Grid>
    </Grid>
  )
}
